import type { FrontendOnlyPieces } from '../../hooks/useSettings/WebsiteSettings';
import { Icon } from '@iconify/react';
import smokeIcon from '@iconify-icons/wi/smoke';
import DomainIcon from '@mui/icons-material/Domain';
import StoreIcon from '@mui/icons-material/Store';
import type { $TSFixMe } from '@calefy-inc/utilityTypes';

const tileIcons = (internalName: string) => {
  switch (internalName) {
    case 'manufacturer_of_vape_ecigarettes':
      return <DomainIcon color='inherit' fontSize='large' />;
    case 'retail_vape_ecigarette':
      return <StoreIcon color='inherit' fontSize='large' />;
    case 'wholesaler_of_vape_ecigarette_products':
      return <Icon icon={smokeIcon} width={'35px'} />;

    default:
      return <Icon icon={smokeIcon} width={'35px'} />;
  }
};

const businessFilter = (business: $TSFixMe) => {
  const allowedBusinessNames = [
    'manufacturer_of_vape_ecigarettes',
    'retail_vape_ecigarette',
    'wholesaler_of_vape_ecigarette_products',
  ];
  if (
    process.env.NODE_ENV !== 'production' ||
    window.location.origin === 'https://staging-calefy.fuseinsurance.ca'
  ) {
    allowedBusinessNames.push('testing_business');
  }
  return allowedBusinessNames.includes(business.internalName);
};

// Vape Insurance — frontend-only pieces; all data fields live on the backend
export const frontendPieces: FrontendOnlyPieces = {
  slug: 'vapeinsurance',
  businessFilter,
  tileIcons,
};
